import React, { useState, useEffect } from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import NewResumeTemplate from './NewResumeTemplate';
import Button from 'components/Button';
import { formatStudentData, formatResumeData } from './utils';

const ResumeDownload = ({ triggerButton, studentData }) => {
  const [formattedData, setFormattedData] = useState(null);
  useEffect(() => {
    const processData = async () => {
      try {
        const formattedStudent = await formatStudentData(studentData);
        const formatted = await formatResumeData(formattedStudent);
        setFormattedData(formatted);
      } catch (error) {
        console.error('Error formatting resume data:', error);
      }
    };
    processData();
  }, [studentData]);

  if (!formattedData) {
    return <div>Loading...</div>;
  }

  return (
    <PDFDownloadLink
      document={<NewResumeTemplate data={formattedData} />}
      fileName={`${studentData?.firstName} ${studentData?.lastName} Resume.pdf`}
    >
      {({ blob, url, loading, error }) =>
        loading ? 'Loading document...' : triggerButton
      }
    </PDFDownloadLink>
  );
};

export default ResumeDownload;
